export { AuthenticatorProvider, useAuthenticator } from './Authenticator';